/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Details connected User.
 * @export
 * @interface GetConnectedUserInfosResponse
 */
export interface GetConnectedUserInfosResponse {
    /**
     * Last name of the individual
     * @type {string}
     * @memberof GetConnectedUserInfosResponse
     */
    lastName: string;
    /**
     * First name of the individual
     * @type {string}
     * @memberof GetConnectedUserInfosResponse
     */
    firstName: string;
    /**
     * Email address of the individual
     * @type {string}
     * @memberof GetConnectedUserInfosResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GetConnectedUserInfosResponse
     */
    companyName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetConnectedUserInfosResponse
     */
    roles?: Array<string>;
}

/**
 * Check if a given object implements the GetConnectedUserInfosResponse interface.
 */
export function instanceOfGetConnectedUserInfosResponse(value: object): value is GetConnectedUserInfosResponse {
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function GetConnectedUserInfosResponseFromJSON(json: any): GetConnectedUserInfosResponse {
    return GetConnectedUserInfosResponseFromJSONTyped(json, false);
}

export function GetConnectedUserInfosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConnectedUserInfosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'email': json['email'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'roles': json['roles'] == null ? undefined : json['roles'],
    };
}

export function GetConnectedUserInfosResponseToJSON(json: any): GetConnectedUserInfosResponse {
    return GetConnectedUserInfosResponseToJSONTyped(json, false);
}

export function GetConnectedUserInfosResponseToJSONTyped(value?: GetConnectedUserInfosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'email': value['email'],
        'companyName': value['companyName'],
        'roles': value['roles'],
    };
}

